export default "__VITE_ASSET__DOp3qi7W__"